import { Controller } from '@hotwired/stimulus';

// The /habits hero demo: a year grid (weeks across, weekdays down) like the
// Track Anything sheet. Each click on the box fills the next day, the same way
// clicking A1 in the sheet does.
export default class extends Controller {
  static targets = ['grid', 'total', 'button'];
  static values = { weeks: { type: Number, default: 26 }, filled: { type: Number, default: 12 } };

  connect() {
    this.count = this.filledValue;
    this.gridTarget.innerHTML = '';
    for (let i = 0; i < this.weeksValue * 7; i += 1) {
      const cell = document.createElement('span');
      cell.className = 'habits-demo__cell';
      if (i < this.count) cell.classList.add('is-done');
      this.gridTarget.appendChild(cell);
    }
    this.render();
  }

  track() {
    const cells = this.gridTarget.children;
    if (this.count >= cells.length) return;
    const cell = cells[this.count];
    cell.classList.add('is-done', 'is-new');
    setTimeout(() => cell.classList.remove('is-new'), 600);
    this.count += 1;
    this.render();
  }

  render() {
    this.totalTargets.forEach((el) => { el.textContent = this.count; });
  }
}
